/**
 * App config
 */
export const config = {
  apiBaseUrl: "https://gh-trending-api.herokuapp.com",
};
